export const TimeoutModal = {
    IDLE_TIME: 1800, //sec
    TIMEOUT_ALERT_TIME: 10  //sec
}